const fallbackApiBaseUrl =
  import.meta.env.VITE_API_URL || import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

export async function bootstrapTenantRuntime() {
  const apiBaseUrl = fallbackApiBaseUrl;

  try {
    const response = await fetch(`${apiBaseUrl}/api/tenant-config`, {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Tenant bootstrap failed with status ${response.status}`);
    }

    const tenant = await response.json();
    if (tenant.authProvider !== 'google_identity_platform' ||
        !tenant.centralAuth?.apiKey || !tenant.centralAuth?.projectId ||
        !tenant.centralAuth?.authDomain || !tenant.centralAuth?.appId) {
      throw new Error('Identity Platform browser config is missing for this workspace.');
    }

    window.__TENANT_RUNTIME__ = {
      apiBaseUrl,
      tenant,
    };
  } catch (error) {
    console.error('Workspace identity bootstrap failed.', error);
    throw error;
  }

  return window.__TENANT_RUNTIME__;
}

export function getTenantRuntime() {
  return (
    window.__TENANT_RUNTIME__ || {
      apiBaseUrl: fallbackApiBaseUrl,
      tenant: null,
    }
  );
}
